export default __webpack_public_path__ + "static/media/DNo.24-4.0499e0f7.jpg";